import { Component, OnInit, Inject } from '@angular/core';
import { UsersService } from "../../services/users/users.service";
import { LoginService } from "../../services/login/login.service";
import {MatSnackBar} from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'app-modal-new-user',
  templateUrl: './modal-new-user.component.html',
  styleUrls: ['./modal-new-user.component.css']
})
export class ModalNewUserComponent implements OnInit {

  nombre1: any;
  nombre2: any;
  apellido1: any;
  apellido2: any;
  tipoDoc: any;
  numDoc: any;
  email: any;
  user: any;
  pass: any;
  rol: any;
  edit: boolean;
  disabled: boolean[]=[];

  constructor(
    public userService: UsersService,
    public loginService: LoginService,
    private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ModalNewUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.edit = this.data.edit;
    if (this.edit) {
      this.userService.getUser(data.idUser).subscribe((data: {}) => {
        this.nombre1 = data["usuario_realgisNombre1"];
        this.nombre2 = data["usuario_realgisNombre2"];
        this.apellido1 = data["usuario_realgisApellido1"];
        this.apellido2 = data["usuario_realgisApellido2"];
        this.tipoDoc = data["usuario_realgisTipo"];
        this.numDoc = data["usuario_realgisDoc"];
        this.email = data["usuario_realgisCorreo"];
        this.user = data["usuario_realgisUsuario"];
        this.pass = data["usuario_realgisClave"];
        this.rol = data["usuario_realgisRolIni"];
        this.disabled = [false, false, false, false, false, false, false, false, false, false, false];
      });
    }else{
      this.disabled = [true, true, true, true, true, true, true, true, true, true, true];
    }
   }

  ngOnInit(): void {
  }


  createUser(){
    const user = {
      usuario_realgisTipo: this.tipoDoc,
      usuario_realgisDoc: this.numDoc,
      usuario_realgisNombre1: this.nombre1,
      usuario_realgisNombre2: this.nombre2,
      usuario_realgisApellido1: this.apellido1,
      usuario_realgisApellido2: this.apellido2,
      usuario_realgisUsuario: this.user,
      usuario_realgisClave: this.pass,
      usuario_realgisEstado: 1,
      usuario_realgisCorreo: this.email,
      usuario_realgisUsuarioCreacion: this.loginService.userName + " " + this.loginService.userLastname, 
      usuario_realgisRolIni: this.rol
    };

this.userService.createNewUser(user).subscribe((data: {}) => {
  if (data["SDTReporteErrores"][0]["Id"] == 1) {
    this.dialogRef.close();
  }
 this._snackBar.open(data["SDTReporteErrores"][0]["Descipcion"], "OK", {
    duration: 5000,
  });
});
  }

  editUser(){

    const user = {
      usuario_realgisId: this.data.idUser,
      usuario_realgisTipo: !this.disabled[4] ? "" : this.tipoDoc,
      usuario_realgisDoc: !this.disabled[5] ? "" : this.numDoc,
      usuario_realgisNombre1: !this.disabled[0] ? "" : this.nombre1,
      usuario_realgisNombre2: !this.disabled[1] ? "" : this.nombre2,
      usuario_realgisApellido1: !this.disabled[2] ? "" : this.apellido1,
      usuario_realgisApellido2: !this.disabled[3] ? "" : this.apellido2,
      usuario_realgisUsuario: !this.disabled[7] ? "" : this.user,
      usuario_realgisClave: !this.disabled[8] ? "" : this.pass,
      usuario_realgisEstado: "",
      usuario_realgisCorreo: !this.disabled[6] ? "" : this.email,
    };
 this.userService.editUser(user).subscribe((data: {}) => {
   if (data["SDTReporteErrores"].length == 0) {
     this.dialogRef.close();
     this._snackBar.open("El Usuario se Edito correctamente", "OK", {
    duration: 5000
  });
}
  }); 
}

}
